import React from 'react'
import PunchCard from '../../smartphone/PunchCard'
import {
  Grid,
  Typography,
  AccordionGroup,
  Container,
  accordionClasses,
  Divider,
  Card,
  accordionSummaryClasses,
  accordionDetailsClasses,
  CircularProgress,
} from '@mui/joy'
import { useGetStoreDataQuery } from '../../services/branding'
import TextSettings from './display/TextSettings'
import CardSettings from './display/CardSettings'
import BackGroundSettings from './display/BackGroundSettings'

function Display() {
  const { data: store, isLoading: isStoreDataLoading } = useGetStoreDataQuery()

  if (isStoreDataLoading) {
    return (
      <Container maxWidth="xs">
        <Grid container justifyContent="center" style={{ minHeight: '100vh' }}>
          <CircularProgress size="lg" />
        </Grid>
      </Container>
    )
  }

  return (
    <>
      <Grid>
        <Container>
          <Typography level="h4" sx={{ mb: 2 }}>
            Kinézet
          </Typography>
          <Divider />
        </Container>
      </Grid>
      <Container sx={{ pt: 3 }}>
        <Grid container>
          <Grid xs={12} md={7.5} lg={6.5} sx={{ pb: 3 }}>
            <Container>
              <Card>
                <AccordionGroup
                  sx={(theme) => ({
                    [`& .${accordionClasses.root}`]: {
                      marginTop: '.5rem',
                      transition: '0.2s ease',
                      '& button:not([aria-expanded="true"])': {
                        transition: '0.2s ease',
                      },
                      '& button:hover': {
                        background: 'transparent',
                      },
                    },
                    [`& .${accordionClasses.root}.${accordionClasses.expanded}`]:
                      {
                        bgcolor: 'background.level1',
                        borderRadius: 'md',
                        borderBottom: '1px solid',
                        borderColor: 'background.level2',
                      },
                    '& [aria-expanded="true"]': {
                      boxShadow: `inset 0 -1px 0 ${theme.vars.palette.divider}`,
                    },
                    borderRadius: 'md',
                    [`& .${accordionDetailsClasses.content}.${accordionDetailsClasses.expanded}`]:
                      {
                        paddingBlock: '1rem',
                      },
                    [`& .${accordionSummaryClasses.button}`]: {
                      paddingBlock: '1rem',
                    },
                  })}
                >
                  <CardSettings numberOfStamps={store!.numberOfStamps} />
                  <TextSettings />
                  <BackGroundSettings />
                </AccordionGroup>
              </Card>
            </Container>
          </Grid>
          <Grid xs={12} md={4.5} sx={{ pt: 2 }}>
            <Container>
              <PunchCard />
            </Container>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default Display
